import { sdk } from '@mesa-labs/mesa-api';

export function parsePermissions(idTokenPayload: Record<string, unknown>): sdk.AuthPermission[] {
  const raw = idTokenPayload['permissions'] as string | undefined;
  try {
    const parsed: string[] = raw ? JSON.parse(raw) : [];
    return parsed.filter(p => Object.values(sdk.AuthPermission).includes(p as sdk.AuthPermission)) as sdk.AuthPermission[];
  } catch (_) {
    return [];
  }
}
